<app-default-layout
  [title]="'REGISTRIERUNG.TITLE'"
  >

  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form [formGroup]="registrierungForm" (ngSubmit)="this.create()" class="form-horizontal"
        accept-charset="UTF-8">

        @if (isVisible('name')) {
          <div class="form-group sfk-form-vertical-spacer group-for-name  mb-0"
            >
            <app-custom-input id="name"
              type="text"
              [customFormGroup]="registrierungForm"
              [label]="getFieldLabelOrTranslate('name','REGISTRIERUNG.NAME')"
              data-cy="nachname"
            ></app-custom-input>
          </div>
        }

        @if (isVisible('vorname')) {
          <div class="form-group sfk-form-vertical-spacer group-for-vorname  mb-0"
            >
            <app-custom-input id="vorname"
              type="text"
              [customFormGroup]="registrierungForm"
              [label]="getFieldLabelOrTranslate('vorname','REGISTRIERUNG.VORNAME')"
              data-cy="vorname"
            ></app-custom-input>
          </div>
        }

        @if (isVisible('geburtsdatum')) {
          <div class="form-group sfk-form-vertical-spacer group-for-geburtsdatum  mb-0"
            >
            <app-custom-input id="geburtsdatum"
              type="date"
              [customFormGroup]="registrierungForm"
              [label]="getFieldLabelOrTranslate('geburtsdatum','REGISTRIERUNG.BDAY')"
              data-content="dd.mm.yyyy"
              [max]="this.maxDate | date:'yyyy-MM-dd'"
              [min]="this.minDateBirthday | date:'yyyy-MM-dd'"
              [infoTextBelowInput]="getTextbausteinOrTranslate(KeyString.GEBURTSDATUM_INFO_BELOW,'')"
              data-cy="geburtsdatum"
            ></app-custom-input>
          </div>
        }

        @if (isVisible('email')) {
          <div class="form-group sfk-form-vertical-spacer group-for-email  mb-0"
            >
            <app-custom-input id="email"
              type="text"
              [customFormGroup]="registrierungForm"
              [label]="getFieldLabelOrTranslate('email','REGISTRIERUNG.MAIL')"
              data-cy="email"
            ></app-custom-input>
            @if (registrierungForm?.controls?.email?.invalid) {
              <div class="formcontrol-error-infotext"
                data-cy="email-error"
                >
                {{ 'AUTHENTICATION.FORM_ERRORS.EMAIL_INVALID' | translate }}
              </div>
            }
          </div>
        }

        @if (isVisible('emailbestaetigung')) {
          <div class="form-group sfk-form-vertical-spacer group-for-emailbestaetigung  mb-0"
            >
            <app-custom-input id="emailbestaetigung"
              type="text"
              [customFormGroup]="registrierungForm"
              [label]="getFieldLabelOrTranslate('emailbestaetigung','REGISTRIERUNG.MAIL-CONFIRMATION')"
              data-cy="emailbestaetigung"
            ></app-custom-input>
            @if (registrierungForm?.get('emailbestaetigung')?.errors) {
              <div class="formcontrol-error-infotext"
                data-cy="emailbestaetigung-error"
                >
                {{ registrierungForm?.get('emailbestaetigung')['infotextKey'] | translate }}
                <!-- error generated by angular's Validators.email, if format is wrong : -->
                @if (registrierungForm?.get('emailbestaetigung')?.errors?.email) {
                  <div>
                    {{ 'AUTHENTICATION.FORM_ERRORS.EMAIL_INVALID' | translate }}
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (isVisible('kennwort')) {
          <div class="form-group sfk-form-vertical-spacer group-for-kennwort  mb-0"
            >
            <div class="d-flex flex-row">
              <div class="flex-grow-1">
                <app-custom-input id="kennwort"
                  type="text"
                  [type] = "pwHide? 'password':'text'"
                  [customFormGroup]="registrierungForm"
                  [label]="getFieldLabelOrTranslate('kennwort','REGISTRIERUNG.PW')"
                  [infoTextBelowInput]="translateService.instant('AUTHENTICATION.FORM_ERRORS.PASSWORD_REQUIREMENTS')"
                  data-cy="kennwort"
                ></app-custom-input>
                @if (registrierungForm?.get('kennwort')?.errors) {
                  <div class="formcontrol-error-infotext"
                    data-cy="kennwort-error">
                    {{ registrierungForm?.get('kennwort')['infotextKey'] | translate }}
                    {{ registrierungForm?.get('kennwort')['lengthKey'] | translate }}
                    {{ registrierungForm?.get('kennwort')['numKey'] | translate }}
                    {{ registrierungForm?.get('kennwort')['upperKey'] | translate }}
                    {{ registrierungForm?.get('kennwort')['lowerKey'] | translate }}
                    {{ registrierungForm?.get('kennwort')['specialKey'] | translate }}
                  </div>
                }
              </div>
              <fa-icon  style="margin-left: -27px; padding-top: 19px; margin-top: 17px; width: 26px; z-index:100"
                [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                [title]="pwHide? translateService.instant('LOGIN.PW-SHOW'):translateService.instant('LOGIN.PW-HIDE')"
                data-cy="btn-pwhide"
                >
              </fa-icon>
            </div>
          </div>
        }

        @if (isVisible('kennwortbestaetigung')) {
          <div class="form-group sfk-form-vertical-spacer group-for-kennwortbestaetigung  mb-3"
            >
            <div class="d-flex flex-row">
              <div class="flex-grow-1">
                <app-custom-input id="kennwortbestaetigung"
                  type="text"
                  [type] = "pwHide? 'password':'text'"
                  [customFormGroup]="registrierungForm"
                  [label]="getFieldLabelOrTranslate('kennwort','REGISTRIERUNG.PW-CONFIRMATION')"
                  data-cy="kennwortbestaetigung"
                ></app-custom-input>
                @if (registrierungForm?.controls?.kennwortbestaetigung?.errors) {
                  <div class="formcontrol-error-infotext"
                    data-cy="kennwortbestaetigung-error"
                    >
                    {{ registrierungForm?.get('kennwortbestaetigung')['infotextKey'] | translate }}
                  </div>
                }
              </div>
              <fa-icon  style="margin-left: -27px; padding-top: 19px; margin-top: 17px; width: 26px; z-index:1"
                [icon]="pwHide? faEye:faEyeSlash" (click) = "pwHide=!pwHide"
                [title]="pwHide? translateService.instant('LOGIN.PW-SHOW'):translateService.instant('LOGIN.PW-HIDE')"
                data-cy="btn-pwhide-repeat"
                >
              </fa-icon>
            </div>
          </div>
        }

        <div class="form-group sfk-form-vertical-spacer group-for-nutzungsbedingungen  mb-0">
          <div class="custom-control-inline custom-checkbox group-for-nutzungsbedingungen d-flex flex-row" data-cy="check-nutzungsbedingungen">
            <label class="checkbox-container">
              {{getFieldLabelOrTranslate('nutzungsbedingungen','REGISTRIERUNG.CHECKBOX1')}}
              <input type="checkbox" class="control control-checkbox custom-control-input" formControlName="nutzungsbedingungen"
                id="nutzungsbedingungen"
                name="nutzungsbedingungen"
                >
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
          <div class="form-group sfk-form-vertical-spacer group-for-datenschutz  mb-0">
            <div class="custom-control-inline custom-checkbox group-for-datenschutz d-flex flex-row" data-cy="check-datenschutz">
              <label class="checkbox-container">
                {{getFieldLabelOrTranslate('datenschutz','REGISTRIERUNG.CHECKBOX2')}}
                <input type="checkbox" class="control control-checkbox custom-control-input" formControlName="datenschutz"
                  id="datenschutz"
                  name="datenschutz"
                  >
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <br>
              <button type="submit" class="btn btn-primary save btn-block me-3" data-cy="btn-submit">
                {{'APPLICATION.BUTTON_REGISTRIEREN'|translate}}
              </button>
              <button type="button" class="btn btn-secondary btn-block me-3" (click)="openDialog()" data-cy="btn-datenschutz">Datenschutzerklärung lesen</button>
              <button type="button" class="btn btn-secondary btn-block me-3" [routerLink]="['/authentication/login']" data-cy="btn-backtologin">Zurück zum Login</button>
            </form>
          </div>
        </div>
        <br/>
      </app-default-layout>
